import React from 'react';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import useAutoTranslate from '../hooks/useAutoTranslate';

const Breadcrumbs = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams(); // Parámetros dinámicos de la URL
  const { autoT } = useAutoTranslate();

  // Definir las rutas principales
  const routes = {
    '/home': autoT('Inicio'),
    '/order-detail/:id': autoT('Orden de compra'),
    '/create-asn/:id': autoT('Crear notificación'),
    '/ramp/:id': autoT('Rampla'),
    '/asn/:id': autoT('Notificación'),
    '/edit-asn/:id': autoT('Editar notificación'),
    '/user-list': autoT('Listado de usuarios'),
    '/create-ramp': autoT('Crear rampla'),
    '/create-assignment/:id': autoT('Asignar'),
    '/orderlist': autoT('Lista órdenes'),
    '/notificationslist': autoT('Lista de notificaciones'),
    '/suppliers': autoT('Lista de proveedores'),
    '/roles': autoT('Lista de roles'),
    '/roles/create': autoT('Crear Rol'),
    '/roles/:id': autoT('Editar Rol'),
    '/districts': autoT('Lista de distritos'),
    '/ramplas': autoT('Lista de ramplas'),
    '/sending': autoT('Lista de entregas'),
    '/asn-draft/:id': autoT('Borrador'),
    '/system-config': autoT('Configuraciones del Sistema'),
    '/shipping-methods': autoT('Lista de métodos de envío'),
  };

  // Función para obtener los breadcrumbs
  const getBreadcrumbs = () => {
    const breadcrumbs = [autoT('Inicio')];

    if (location.pathname === '/home') {
      return breadcrumbs;
    }

    if (/^\/order-detail\/\w+/.test(location.pathname)) {
      breadcrumbs.push(autoT('Lista Órdenes'));
      breadcrumbs.push(routes['/order-detail/:id']);
    } else if (/^\/create-asn\/\w+/.test(location.pathname)) {
      breadcrumbs.push(autoT('Lista Órdenes'));
      breadcrumbs.push(autoT('Orden de compra'));
      breadcrumbs.push(routes['/create-asn/:id']);
    } else if (/^\/asn\/\w+/.test(location.pathname)) {
      breadcrumbs.push(autoT('Lista Notificaciones'));
      breadcrumbs.push(routes['/asn/:id']);
    } else if (/^\/edit-asn\/\w+/.test(location.pathname)) {
      breadcrumbs.push(autoT('Lista Notificaciones'));
      breadcrumbs.push(routes['/asn/:id']);
      breadcrumbs.push(routes['/edit-asn/:id']);
    } else if (location.pathname === '/user-list') {
      breadcrumbs.push(routes['/user-list']);
    } else if (location.pathname === '/schedule-list') {
      breadcrumbs.push(autoT('Lista de agendamientos'));
    } else if (/^\/ramp\/\w+/.test(location.pathname)) {
      breadcrumbs.push(autoT('Lista Ramplas'));
      breadcrumbs.push(routes['/ramp/:id']);
    } else if (/^\/create-assignment\/\w+/.test(location.pathname)) {
      breadcrumbs.push(autoT('Lista Ramplas'));
      breadcrumbs.push(routes['/ramp/:id']);
      breadcrumbs.push(routes['/create-assignment/:id']);
    } else if (location.pathname === '/create-ramp') {
      breadcrumbs.push(autoT('Lista Ramplas'));
      breadcrumbs.push(routes['/create-ramp']);
    } else if (location.pathname ==='/trucks'){
      breadcrumbs.push(autoT('Lista de Equipos'));
    } else if (location.pathname ==='/truck-types'){
      breadcrumbs.push(autoT('Lista de Tipos de Equipos'));
    } else if (location.pathname ==='/districs'){
        breadcrumbs.push(autoT('Lista de Distritos'));
    } else if (location.pathname ==='/centers'){
      breadcrumbs.push(autoT('Lista de Centros'));
    } else if (location.pathname ==='/warehouses'){
      breadcrumbs.push(autoT('Lista de Bodegas'));
    } else if (location.pathname ==='/companies'){
      breadcrumbs.push(autoT('Lista de Compañias'));
    } else if (location.pathname === '/orderlist') {
      breadcrumbs.push(routes['/orderlist']);
    } else if (location.pathname === '/notificationslist') {
      breadcrumbs.push(routes['/notificationslist']);
    } else if (location.pathname === '/suppliers') {
      breadcrumbs.push(routes['/suppliers']);
    } else if (location.pathname === '/roles') {
      breadcrumbs.push(routes['/roles']);
    } else if (location.pathname === '/roles/create') {
      breadcrumbs.push(routes['/roles']);
      breadcrumbs.push(routes['/roles/create']);
    } else if (/^\/roles\/\w+/.test(location.pathname) && id) {
      breadcrumbs.push(routes['/roles']);
      breadcrumbs.push(routes['/roles/:id']);
    } else if (location.pathname === '/districts') {
      breadcrumbs.push(routes['/districts']);
    } else if (location.pathname === '/ramplas') {
      breadcrumbs.push(routes['/ramplas']);
    } else if (location.pathname === '/sending') {
      breadcrumbs.push(routes['/sending']);
    } else if (/^\/asn-draft\/\w+/.test(location.pathname)) {
      breadcrumbs.push(routes['/notificationslist']); // "Listado de notificaciones"
      breadcrumbs.push(routes['/asn-draft/:id']); // "Borrador"
    } else if (location.pathname === '/system-config') {
      breadcrumbs.push(routes['/system-config']);
    } else if (location.pathname === '/shipping-methods') {
      breadcrumbs.push(routes['/shipping-methods']);
    } else {
      console.warn('Ruta no identificada en Breadcrumbs:', location.pathname);
    }

    return breadcrumbs;
  };

  // Generar enlaces para cada breadcrumb
  const handleBreadcrumbNavigation = (index) => {
    const path = location.pathname; // Obtener la ruta actual para lógica condicional
    switch (index) {
      case 0:
        navigate('/home'); // Navegar a "Inicio"
        break;
      case 1:
        if (path.includes('order-detail') || path.includes('create-asn')) {
          navigate('/home', { state: { activePart: 'home', selectedTab: 'buyorder' } }); // Lista de Órdenes
        } else if (path.includes('asn') || path.includes('edit-asn')) {
          navigate('/home', { state: { activePart: 'home', selectedTab: 'notification' } }); // Lista de ASN
        } else if (path === '/user-list') {
          navigate('/home', { state: { activePart: 'home', selectedTab: 'home' } }); // Listado de Usuarios
        } else if (path.includes('ramp') || path.includes('create-ramp') || path.includes('create-assignment')) {
          navigate('/home', { state: { activePart: 'home', selectedTab: 'virtualramp' } }); // Lista de Ramplas
        } else if (path === '/schedule-list') {
          navigate('/home', { state: { activePart: 'home', selectedTab: 'schedules' } }); // Lista de Agendamientos
        } else if (path.includes('/roles')) {
          navigate('/roles'); // Lista de roles
        }
        break;
      case 2:
        if (path.includes('order-detail')) {
          navigate(`/order-detail/${id}`); // Orden de compra
        } else if (path.includes('create-asn')) {
          navigate(`/order-detail/${id}`); // Orden de compra
        } else if (path.includes('asn') || path.includes('edit-asn')|| path.includes('asn-draft')) {
          navigate(`/asn/${id}`); // ASN
        } else if (path.includes('ramp') || path.includes('create-assignment')) {
          navigate(`/ramp/${id}`);
        } else if (path === '/create-ramp') {
          navigate('/create-ramp');
        } else if (path.includes('/roles')) {
          // If it's /roles/create, navigate to /roles, otherwise navigate to /roles/:id
          if (path.includes('/roles/create')) {
            navigate('/roles/create');
          } else if (path.includes('/roles/')) {
            navigate(`/roles/${id}`);
          }
        }
        break;
      case 3:
        if (path.includes('create-asn')) {
          navigate(`/create-asn/${id}`); // Crear ASN
        } else if (path.includes('edit-asn')) {
          if (getBreadcrumbs()[index] === routes['/edit-asn/:id']) {
            navigate(`/edit-asn/${id}`);
          } else {
            navigate(`/asn/${id}`); // Ir al detalle
          }
        } else if (path.includes('create-assignment')) {
          navigate(`/create-assignment/${id}`);
        }
        break;
      case 4:
        if (path.includes('edit-asn')) {
          navigate(`/edit-asn/${id}`);
        }
        break;
        case 5:
          if (path.includes('asn-draft')) {
            navigate(`/asn-draft/${id}`); // Navegar al draft actual
          } else if (path.includes('asn') || path.includes('edit-asn')) {
            navigate(`/asn/${id}`);
          }
          break;
      default:
        console.warn('Índice de Breadcrumb no manejado:', index);
    }
  };    

  const breadcrumbLinks = getBreadcrumbs();

  return (
    <div>
      {breadcrumbLinks.map((breadcrumb, index) => (
        <span key={index}>
          {index > 0 && <span style={{ marginRight: '20px', marginLeft: '20px' }}> {'>'} </span>}
          <span
            style={{
              cursor: 'pointer',
              color: 'black',
              textDecoration: 'none',
              fontSize: '16px',
              fontWeight: index === breadcrumbLinks.length - 1 ? 'bold' : 'normal'
            }}
            onMouseEnter={(e) => {
              e.target.style.textDecoration = 'underline'; // Añadir subrayado cuando el mouse pasa por encima
            }}
            onMouseLeave={(e) => {
              e.target.style.textDecoration = 'none'; // Quitar subrayado cuando el mouse sale
            }}
            onClick={() => handleBreadcrumbNavigation(index)}
          >
            {breadcrumb}
          </span>
        </span>
      ))}
    </div>
  );
};

export default Breadcrumbs;